import React from "react";
import "./Item.css";
import PopupCompetition from "shared/components/popups/PopupCompetition";
import ButtonMflCompetition from "shared/components/buttons/ButtonMflCompetition.js";


interface ItemRowCompetitionProps {
  c: object;
  trigger?: object;
  hideSeason?: Boolean;
  className?: String;
}

const ItemRowCompetition: React.FC<ItemRowCompetitionProps> = ({ c, trigger, hideSeason, className }) => {
  return (
    <div className={"Item d-flex flex-row flex-fill " + (className ? className : "")}>
      <PopupCompetition
        className="flex-fill"
        competition={c}
        trigger={
          trigger ? (
            trigger
          ) : (
            <div className={"w-100 " + (className ? className : "")}>
              <div className="d-flex flex-row flex-fill pb-1 pb-md-0">
                <div className="d-flex flex-md-basis-300">
                  <i className="bi bi-trophy-fill me-1" />
                  <div className="d-flex flex-grow-1">{c.name ? c.name : ""}</div>
                </div>

                {!hideSeason && <div className="d-flex flex-grow-1">{c.seasonName ? c.seasonName : ""}</div>}
                <div className="d-flex flex-fill justify-content-end">
                <ButtonMflCompetition id={c.id} />
                </div>
              </div>
            </div>
          )
        }
      />
    </div>
  );
};

export default ItemRowCompetition;
